import { MbscModule } from '@mobiscroll/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { HTTP } from '@ionic-native/http/ngx';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { VideoPopComponent } from './pages/video-pop/video-pop.component';
import { PaymentPopComponent } from './pages/payment-pop/payment-pop.component';
import { Camera } from '@ionic-native/camera/ngx';
import { MatVideoModule } from 'mat-video';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
import { environment } from '../environments/environment';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireModule } from '@angular/fire';

import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { File } from '@ionic-native/file/ngx';
import { CallNumber } from '@ionic-native/call-number/ngx';
import { HttpClientModule } from '@angular/common/http';
import { RealtimePopComponent } from './realtime-pop/realtime-pop.component';

@NgModule({
  declarations: [
    AppComponent,
    VideoPopComponent,
    PaymentPopComponent,
    RealtimePopComponent,
  ],
  entryComponents: [
    VideoPopComponent,
    PaymentPopComponent,
    RealtimePopComponent,
  ],
  imports: [
    MbscModule,
    FormsModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserModule,
    IonicModule.forRoot({ mode: 'ios' }),
    AppRoutingModule,
    BrowserAnimationsModule,
    MatVideoModule,
  ],
  providers: [
    HTTP,
    StatusBar,
    SplashScreen,
    Camera,
    File,
    CallNumber,
    AndroidPermissions,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
